import { ResponseCode } from "chat/enums";
import { StreamDetailType } from "src/features/homePage/shared/imports/types";

export interface GetLiveBarRequestsParams {
  accessToPremium?: boolean;
  last_timestamp?: number;
  limit?: number;
  moderation_level?: number;
  refresh?: boolean;
}

export interface GetLiveBarRequestsResponse {
  hasMore?: boolean;
  lastTimestamp?: number;
  responseCode?: ResponseCode;
  streamList?: Array<StreamDetailType>;
}

export enum LiveBarClickTargetProperty {
  LIVE_STREAM_COVER = "live_stream_cover",
}

export enum BadgeType {
  LIVE = "live",
  PREMIUM = "premium",
}
